import styled from "styled-components";

export const PositionCloseWrapper = styled.div``;
export const ClosingPriceQtySection = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	margin-top: 20px;
`
export const PositionCloseSection = styled.div`
	width: 100%;
	padding-inline: 15px;
`
export const PercentageFormWrapper = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	background-color: ${p => p.theme.COLORS.gray};
	justify-content: center;
	align-items: center;
	border-radius: 5px;
`
